const CheckedAnswerNoneSvg = ({ width = 15, height = 40 }) => {
	return (
		<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg">
			<defs>
				<style>
					{
						".checkanswer_svg_grey_class{fill:none;stroke:#808285;stroke-miterlimit:10}"
					}
				</style>
			</defs>
			<circle
				className="checkanswer_svg_grey_class"
				cx={6.08}
				cy={5.13}
				r={4.58}
			/>
			<circle
				className="checkanswer_svg_grey_class"
				cx={6.08}
				cy={18.52}
				r={4.58}
			/>
		</svg>
	);
};

export default CheckedAnswerNoneSvg;
